import type { EventType } from '../types';

export function formatPhone(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  if (digits.length === 11 && digits[0] === '1') {
    return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  return phone;
}

export function formatDate(dateStr: string): string {
  const date = new Date(dateStr + 'T00:00:00');
  return date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
}

export function formatShortDate(dateStr: string): string {
  const date = new Date(dateStr + 'T00:00:00');
  return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
}

export function formatTime(time: string): string {
  if (!time) return '';
  const [h, m] = time.split(':').map(Number);
  const ampm = h >= 12 ? 'PM' : 'AM';
  const hour = h % 12 || 12;
  return `${hour}:${m.toString().padStart(2, '0')} ${ampm}`;
}

export function getEventTypeColor(type: EventType): string {
  switch (type) {
    case 'practice': return 'bg-practice text-white';
    case 'regatta': return 'bg-regatta text-white';
    case 'competition': return 'bg-competition text-white';
    default: return 'bg-gray-500 text-white';
  }
}

export function getEventTypeBorderColor(type: EventType): string {
  switch (type) {
    case 'practice': return 'border-practice';
    case 'regatta': return 'border-regatta';
    case 'competition': return 'border-competition';
    default: return 'border-gray-500';
  }
}

export function getToday(): string {
  return new Date().toISOString().split('T')[0];
}

export function getWeekDates(startDate?: string): string[] {
  const start = startDate ? new Date(startDate + 'T00:00:00') : new Date();
  const day = start.getDay();
  start.setDate(start.getDate() - day); // Start from Sunday
  const dates: string[] = [];
  for (let i = 0; i < 7; i++) {
    const d = new Date(start);
    d.setDate(d.getDate() + i);
    dates.push(d.toISOString().split('T')[0]);
  }
  return dates;
}

export function isToday(dateStr: string): boolean {
  return dateStr === getToday();
}

export function getMapsUrl(address: string): string {
  const encoded = encodeURIComponent(address);
  // iOS Safari opens Apple Maps, Android opens Google Maps
  return `https://maps.apple.com/?q=${encoded}`;
}

export function normalizePhone(phone: string): string {
  return phone.replace(/\D/g, '');
}
